var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('log-inbound',{attrs:{"loading":_vm.loading,"item":_vm.item,"title":"Request Details"}})}
var staticRenderFns = []

export { render, staticRenderFns }